import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getBranchList, createBranch } from "../../services/config";
import { config } from "../../services/configHeader";

const baseUrl = process.env.REACT_APP_BASE_URI;

let initialState = {
  brnLoading: false,
  brnSuccess: false,
  brnError: false,
  brnMessage: null,

  brnGetLoading: false,
  brnGetSuccess: false,
  brnGetError: false,
  brnGetMessage: null,
  brnGetData: null,
};

const user = JSON.parse(localStorage.getItem("user_data")) || {};
const userId = user?.user_id;
const accountType = user?.account_type;

const normalizeThunkError = (error, fallbackMessage = "Request failed") => ({
  status: error?.response?.status || error?.status || 500,
  response: {
    data: {
      ...(error?.response?.data || {}),
      message:
        error?.response?.data?.message ||
        error?.message ||
        fallbackMessage,
      data: error?.response?.data?.data || null,
    },
  },
  message: error?.message || fallbackMessage,
});

export const fetchBranchData = createAsyncThunk("fetchBranchData", async () => {
  return await axios
    .get(`${baseUrl}${getBranchList}${userId}`, config)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      if (!navigator.onLine) {
        let data = {
          response: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
            data: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
        }
         return data
      } else {
        return normalizeThunkError(error, "Failed to load branches")
      }
      
    });
});

export const saveBranch = createAsyncThunk("saveBranch", async (data) => {
  const result = {
    data: {
      message: "Sorry, you can only view the data, not create it.",
      data: [],
    },
  };

  return parseInt(accountType) === 2
    ? result
    : await axios
        .post(`${baseUrl}${createBranch}`, data, config)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          if (!navigator.onLine) {
            return {
              response: {
                data: [],
                message: "No Internet Connection Found",
                success: false,
              },
              data: {
                data: [],
                message: "No Internet Connection Found",
                success: false,
              },
            };
          }
          return normalizeThunkError(error, "Failed to save branch");
        });
});

const branchSlice = createSlice({
  name: "branch",
  initialState,

  reducers: {
    initState: (state) => {
      state.brnLoading = false;
      state.brnSuccess = false;
      state.brnError = false;
      state.brnMessage = null;

      state.brnGetLoading = false;
      state.brnGetSuccess = false;
      state.brnGetError = false;
      state.brnGetMessage = null;
    },
    initBranchState: (state) => {
      state.brnLoading = false;
      state.brnSuccess = false;
      state.brnError = false;
      state.brnMessage = null;

      state.brnGetLoading = false;
      state.brnGetSuccess = false;
      state.brnGetError = false;
      state.brnGetMessage = null;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(fetchBranchData.pending, (state, action) => {
      state.brnGetLoading = true;
      state.brnGetSuccess = false;
      state.brnGetError = false;
      state.brnGetMessage = null;
      state.brnGetData = null;
    });
    builder.addCase(fetchBranchData.fulfilled, (state, action) => {
      const payload = action.payload;
      state.brnGetLoading = false;
      if (payload?.status === 200 && payload?.data) {
        state.brnGetSuccess = true;
        state.brnGetError = false;
        state.brnGetMessage = payload.data.message;
        state.brnGetData = payload.data.data;
      } else {
        state.brnGetSuccess = false;
        state.brnGetError = true;
        state.brnGetMessage = payload?.response?.data?.message || payload?.message || "Failed to load branches";
        state.brnGetData = null;
      }
    });
    builder.addCase(fetchBranchData.rejected, (state, action) => {
      state.brnGetLoading = false;
      state.brnGetSuccess = false;
      state.brnGetError = true;
      state.brnGetMessage = action.payload?.data?.message || action.payload?.message || "Failed to load branches";
      state.brnGetData = null;
    });
    // To create branch
    builder.addCase(saveBranch.pending, (state, action) => {
      state.brnLoading = true;
      state.brnSuccess = false;
      state.brnError = false;
      state.brnMessage = null;
    });
    builder.addCase(saveBranch.fulfilled, (state, action) => {
      const payload = action.payload || {};
      const body = payload.data || {};
      const responseBody = payload.response?.data || {};
      state.brnLoading = false;
      state.brnSuccess = (payload.status == 200 || payload.status == 201 || accountType == 2) ? accountType != 2 : false;
      state.brnError = accountType == 2 || !(payload.status == 200 || payload.status == 201);
      state.brnMessage = body.message || body.msg || responseBody.message || payload.message || null;
    });
    builder.addCase(saveBranch.rejected, (state, action) => {
      state.brnLoading = false;
      state.brnSuccess = false;
      state.brnError = true;
      state.brnMessage = action.payload?.response?.data?.message || action.error?.message || "Failed to save branch";
    });
  },
});

export const { initState, initBranchState } = branchSlice.actions;

export default branchSlice.reducer;
